import 'COMMON';
import { oLike } from 'Lib/like/like';
import 'Vendor/owlcarousel/owl.carousel.min';
import 'Vendor/polifill-object-fit-images/polifill-object-fit-images';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/journal/timeline/timeline';
import 'Bem/journal/gallery/gallery';
import 'Bem/journal/article-t/article-t';
import 'Bem/site/form-custom/form-custom';
import 'Bem/journal/text-insert-card/text-insert-card';
import 'Bem/journal/video/video';
import 'Bem/journal/text-insert-article/text-insert-article';
import 'Bem/journal/text-insert/text-insert';
import 'Bem/site/book/book';
import 'Bem/journal/table-list/table-list';
import 'Bem/journal/text-insert-min/text-insert-min';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Bem/site/sales-book/sales-book';

svgSpriteLoader('/journal/timeline/svg/sprite.svg?v=20181106');
oLike.init('.js-book-like, .js-article-like');